const JOB_FUNCTION = [
	{ value: 1, text: 'Dealership owner', railsValue: 1 },
	{ value: 2, text: 'Officer', railsValue: 2 },
	{ value: 3, text: 'Sales rep', railsValue: 3 },
	{ value: 4, text: 'Buyer', railsValue: 4 },
	{ value: 5, text: 'Other', railsValue: 0 },
];

export default JOB_FUNCTION;
